import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackBillingInfoChangedParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/account/trackBillingInfoChanged";

const useTrackBillingInfoChanged = (
    parameters: TrackBillingInfoChangedParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.billingInfoChanged, parameters, options);
};

export default useTrackBillingInfoChanged;
